import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';

import css from './ReviewWidget.module.css';

// The provider's embed for toastably's kundenversprechen.ch profile.
const REVIEW_WIDGET_URL = 'https://www.konsumentenbund.ch/widget/widgetpro.php?id=75586&ne=true';

/**
 * kundenversprechen.ch review widget (the certified seal with stars and the
 * review count), served by konsumentenbund.ch. Rendered inside
 * TrustBadgesPanel, which stays hidden until this iframe's onLoad fires.
 * Loaded eagerly: it is the slowest piece of the panel and always in the
 * viewport, so lazy-loading only delayed the reveal. The iframe hosts must
 * stay allowlisted in server/csp.js frameSrc. Review content is managed by
 * the client on kundenversprechen.ch — a low or empty count is not a bug
 * here.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {Function?} props.onLoad fires when the embedded page has loaded
 */
const ReviewWidget = props => {
  const { rootClassName, className, onLoad } = props;
  const intl = useIntl();
  const classes = classNames(rootClassName || css.root, className);

  return (
    /* The sandbox grants what the widget actually needs — scripts (it
       unhides itself), its own origin (the dismiss XHR and fonts) and
       popups (its profile link opens a new tab) — and blocks everything
       else, top navigation included. scrolling="no" is deprecated but still
       the only way to stop the embedded document itself from scrolling: CSS
       overflow on the frame can't reach it, and the provider's page
       overflows the 136px card slightly. */
    <iframe
      className={classes}
      src={REVIEW_WIDGET_URL}
      title={intl.formatMessage({ id: 'ReviewWidget.title' })}
      sandbox="allow-scripts allow-same-origin allow-popups"
      scrolling="no"
      onLoad={onLoad}
    />
  );
};

export default ReviewWidget;
